import { useRouteLoaderData } from 'react-router-dom';
import { User } from '../types';

export const useUser = () => {
  return useRouteLoaderData('user') as User;
};
